import { atom } from "recoil";

export const selectedShapeForHiddenState = atom({
  key: "selectedShapeForHiddenState",
  default: {},
});
